import React, { type SyntheticEvent } from "react";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { IconCart } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { useBnbSelector } from "../../../../redux/store";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import { countBasketItems } from "../../../../utils/typedUtils";
import * as Styles from "./styles/BasketButton";
import Price from "../price/Price";
import { useBnbOptionalLabel } from "../../../../utils/labels";

type PropsType = {
    basketOpen: boolean;
    toggle: (event: SyntheticEvent) => void;
};

const enabledSteps = [NavStep.Customize, NavStep.Services, NavStep.Summary];

const BasketButton = ({ toggle, basketOpen }: PropsType): JSX.Element | null => {
    const step = useBnbSelector((state) => state.navigation.step);
    const basketTotalPrice = useBnbSelector((state) => state.basket.total);
    const selectedItems = useBnbSelector(countBasketItems);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const financeInfo = useBnbSelector((state) => state.finance.info);
    const guideLabel = useBnbOptionalLabel("mobileFooterDisclaimerMonthly");
    const financeOptionTitleCashLabel = useBnbOptionalLabel("financeOptionTitleCash");
    const financeOptionTitleMonthlyLabel = useBnbOptionalLabel("financeOptionTitleMonthly");

    // hide basket on model, engine and buy
    if (!enabledSteps.includes(step)) return null;

    return (
        <Styles.Wrapper>
            <Styles.Button onClick={toggle}>
                {basketOpen ? (
                    <IconWrapper>
                        <IconCart />
                    </IconWrapper>
                ) : (
                    <>
                        <IconCart />
                        {!!selectedItems && <Styles.ItemCount>{selectedItems}</Styles.ItemCount>}
                    </>
                )}
            </Styles.Button>
            <Styles.Pricing>
                {financeOption === "cash" ? (
                    <Styles.FinanceTitle>{financeOptionTitleCashLabel}</Styles.FinanceTitle>
                ) : (
                    <Styles.FinanceTitle>
                        {financeInfo.productName ? financeInfo.productName : financeOptionTitleMonthlyLabel}
                    </Styles.FinanceTitle>
                )}
                {guideLabel && financeOption === "monthly" ? (
                    guideLabel
                ) : (
                    <Price price={basketTotalPrice} financeItemId="total" showLoader />
                )}
            </Styles.Pricing>
        </Styles.Wrapper>
    );
};

export default BasketButton;
